import { Action } from "../../components/types";

interface SetCalendarOpenStateAction extends Action<"SET_CALENDAR_OPEN_STATE"> {
  open: boolean;
}

export const setCalendarOpenState = (open: boolean): SetCalendarOpenStateAction => {
  return { type: "SET_CALENDAR_OPEN_STATE", open };
};

interface SetPreSelectionDateAction extends Action<"SET_PRE_SELECTION_DATE"> {
  date: Date;
  focusOnDate: boolean;
}

export const setPreSelectionDate = (date: Date, focusOnDate: boolean = true): SetPreSelectionDateAction => {
  return { type: "SET_PRE_SELECTION_DATE", date, focusOnDate };
};

interface SetRangeHoverDayAction extends Action<"SET_RANGE_HOVER_DAY"> {
  day: Date | null;
}

export const setRangeHoverDay = (day: Date | null): SetRangeHoverDayAction => {
  return { type: "SET_RANGE_HOVER_DAY", day };
};

interface SetInputValueAction extends Action<"SET_INPUT_VALUE"> {
  value: string;
}

export const setInputValue = (value: string): SetInputValueAction => {
  return { type: "SET_INPUT_VALUE", value };
};

/*-------------------Month Start----------------------- */
interface SetPreviousMonthAction extends Action<"SET_PREVIOUS_MONTH"> {
  step: number;
}

export const setPreviousMonth = (step: number): SetPreviousMonthAction => {
  return { type: "SET_PREVIOUS_MONTH", step };
};

interface SetNextMonthAction extends Action<"SET_NEXT_MONTH"> {
  step: number;
}

export const setNextMonth = (step: number): SetNextMonthAction => {
  return { type: "SET_NEXT_MONTH", step };
};

/*-------------------Month End----------------------- */

/*-------------------Year Start----------------------- */
interface SetPreviousYearAction extends Action<"SET_PREVIOUS_YEAR"> {}

export const setPreviousYear = (): SetPreviousYearAction => {
  return { type: "SET_PREVIOUS_YEAR" };
};

interface SetNextYearAction extends Action<"SET_NEXT_YEAR"> {}

export const setNextYear = (): SetNextYearAction => {
  return { type: "SET_NEXT_YEAR" };
};

/*-------------------Year End----------------------- */

export type CalendarActions =
  | SetCalendarOpenStateAction
  | SetPreSelectionDateAction
  | SetInputValueAction
  | SetRangeHoverDayAction
  | SetPreviousMonthAction
  | SetNextMonthAction
  | SetPreviousYearAction
  | SetNextYearAction;
